function showNewWishListModal (options) {

	const $errorContent = $('#errorContentModal');
	const defaults = {
		onInit: true,
		width: 500,
		height: 100,
		lpModalClass: 'lpModalError',
		content: $errorContent,
		openEvt () {

			$('.btnClose', $errorContent).on('click', () => {

				$('#lpModalClose').trigger('click');

			});

		},
		appendContentToForm: false
	};

	options = $.extend({}, defaults, options);

	$('.errorMessage', $errorContent).html(options.errorMessage);
	$('body').lpModal(options);

}

export default showNewWishListModal;
